// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".bundle-fd0a7030-d8d8-11ef-b4f5-178d2eb96960.js";
};